import React from "react";
import PropTypes from "prop-types";
import AgencyTeamCardHeader from "./header";
import AgencyTeamCardBody from "./body";

function AgencyTeamCard({
  userDetails = {},
  userDomains = [],
  userSubDomains = [],
  users = [],
  updateUsersResult = () => {},
  pagination = {},
}) {
  return (
    <div className="grid  md-max:grid-cols-1 grid-cols-2  w-full h-full items-center gap-[20px]">
      {users.map((user) => {
        return (
          <div
            className="flex flex-col flex-1 w-full h-full flex- py-[20px] px-[16px] gap-[16px]  border-[1px] border-solid border-default-color rounded-[8px]"
            key={user.id}
          >
            <AgencyTeamCardHeader
              userDetails={userDetails}
              userDomains={userDomains}
              userSubDomains={userSubDomains}
              user={user}
              updateUsersResult={updateUsersResult}
              pagination={pagination}
            />

            <AgencyTeamCardBody user={user} />
          </div>
        );
      })}
    </div>
  );
}

AgencyTeamCard.propTypes = {
  userDetails: PropTypes.object,
};

export default AgencyTeamCard;
